import {
  clearSrDocumentActivityAction,
  deleteSrDocumentActivity,
} from 'actions/srDocuments/srDocumentActivityActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const SrDocumentActivityDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentActivityAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteSrDocumentActivity(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this site readiness document activity?
        This can not be undone.
      </div>
    </form>
  )
}

export default SrDocumentActivityDelete
